import { render, staticRenderFns } from "./materialProcessing.vue?vue&type=template&id=48614c94"
import script from "./materialProcessing.vue?vue&type=script&lang=js"
export * from "./materialProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports